import { ReactNode } from 'react';

export type EmployeeDocRequirement =
  | 'all'
  | 'casual'
  | 'fixed_term'
  | 'part_time'
  | 'full_time'
  | 'recommended'
  | 'help_guide'
  | 'as_required';

/** Every `employee_doc_requirements` value, in the order the requirement filter lists them. */
export const EMPLOYEE_DOC_REQUIREMENTS: EmployeeDocRequirement[] = [
  'all',
  'casual',
  'fixed_term',
  'part_time',
  'full_time',
  'recommended',
  'help_guide',
  'as_required',
];

export const EMPLOYEE_DOC_REQUIREMENT_LABEL_KEYS: Record<EmployeeDocRequirement, string> = {
  all: 'employeeDocRequirements.all',
  casual: 'employeeDocRequirements.casual',
  fixed_term: 'employeeDocRequirements.fixedTerm',
  part_time: 'employeeDocRequirements.partTime',
  full_time: 'employeeDocRequirements.fullTime',
  recommended: 'employeeDocRequirements.recommended',
  help_guide: 'employeeDocRequirements.helpGuide',
  as_required: 'employeeDocRequirements.asRequired',
};

export type LibraryItem = {
  id: number;
  category?: string;
  dl_types?: string[];
  dl_workflows?: string[];
  dl_categories?: string[];
  dt_types?: string[];
  dt_workflows?: string[];
  dt_label?: string[];
  name: string;
  updated?: string;
  is_free?: boolean;
  created?: string;
  document_upload?: number;
  user?: number;
  download_link?: string | null;
  region?: string;
  last_used?: string;
  top_template?: boolean;
  top_template_order?: string | null;
  description?: string | null;
  fines?: string | null;
  resolution?: string | null;
  employee_doc_requirements?: EmployeeDocRequirement | string | null;
};

export type LibraryListProps = {
  libraryItems: LibraryItem[];
  cardView?: boolean;
  ownTemplate?: boolean;
  category?: string;
  /** The table sits inside the Library page block, under its action bar (search, view switcher,
   *  Document Terms), next to the page aside, so it has no border / radius of its own. */
  embedded?: boolean;
};

export type RenderActionButtons = (doc: LibraryItem) => ReactNode;

export type LibraryListRowProps = {
  item: LibraryItem;
  renderActionButtons: RenderActionButtons;
  showRequirement?: boolean;
  /** My Templates row: no info bubble, so no info slot either. */
  ownTemplate?: boolean;
};
